$(() => {
    if (document.getElementById('freee-partner') != null) {
        $('.js-remove').on('click', function(e) {
            $('input[name="id"]').val($(this).data('id'));
            $('#freee_remove_form').submit();
        });

        // 一括紐付けボタン有効/無効
        $(".js-check").change(function(){
            if ($('.js-check:checked').length) {
                $('.js-check-btn').prop('disabled', false);
            } else {
                $('.js-check-btn').prop('disabled', true);
            }
        });

        $('.js-register-partner-modal').click(function() {
            let freee_name  = $(this).parent().find('.js-freee-name').text();
            let freee_email = $(this).parent().find('.js-freee-email').text();
            let partner_id  = $(this).parent().find('.js-freee-partner_id').text();
            let _modal      = $('#freee-register-partner-modal');
            _modal.find('.js-modal-freee-name').text(freee_name);
            _modal.find('.js-modal-freee-email').text(freee_email);
            _modal.find('input[name="partner_id"]').val(partner_id);
            _modal.modal('show');
        });

        $('.js-pb-partner').change(function() {
            let val = $('select[name="pool_id"] option:selected').val();
            if (val) {
                $('.js-register-partner-btn').prop('disabled', false);
            } else {
                $('.js-register-partner-btn').prop('disabled', true);
            }
        });
        
        $('.js-register-partner-btn').click(function(){
            $('#freee_partner_register_form').submit();
        });
    }
});
